import API from 'apis/API'

var ChatAPI = {
  // create memo
  createConversation: async function(project_id, content, transcript_id = null) {
    const params = {
      message: {
        content: content,
      }
    };

    if (transcript_id) {
      params.transcript_id = transcript_id;
    }

    return API.post(`/api/projects/${project_id}/conversations`, params);
  },
  createTranscriptConversation: async function(transcript_id, content) {
    const params = {
      message: {
        content: content,
      }
    };

    return API.post(`/api/transcripts/${transcript_id}/conversations`, params);
  },
  createAIConversation: async function(conversation_id, checkedCodes, op, transcripts) {
    return API.post(`/api/conversations/${conversation_id}/messages/ai`, {
      code_ids: checkedCodes,
      op: op,
      transcript_ids: transcripts
    });
  },
  createMessage: async function(conversation_id, content) {
    return API.post(`/api/conversations/${conversation_id}/messages`, {
      content: content,
    });
  },
  getConversation: async function(conversation_id) {
    return API.get(`/api/conversations/${conversation_id}/messages`);
  },
  getConversations: async function(project_id, params = {}) {
    // Filter out null values from params
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== null)
    );
    const queryParams = new URLSearchParams(filteredParams).toString();
    return API.get(`/api/projects/${project_id}/conversations?${queryParams}`, { params: filteredParams });
  },
  deleteConversation: async function(conversation_id) {
    return API.delete(`/api/conversations/${conversation_id}`);
  }
};

export default ChatAPI
